import type { TravellerAge } from "@/types/flights";
import { isEmpty, size } from "lodash";
import { Minus, Plus } from "lucide-react";
import { MouseEventHandler } from "react";
import { CounterAge } from "./CounterAge";

type Props = {
  value: TravellerAge[];
  onDecrement: MouseEventHandler<HTMLButtonElement>;
  onIncrement: MouseEventHandler<HTMLButtonElement>;
  label: string;
  description?: string;
  min?: number;
  onAgeChange: (age: number, travellerId: string) => void;
  ageOptions: number[];
  disabledIncrement?: boolean;
};

export const Counter = ({
  value,
  description,
  onIncrement,
  onDecrement,
  onAgeChange,
  label,
  min = 0,
  ageOptions,
  disabledIncrement,
}: Props) => {
  return (
    <div className="px-4">
      <label className="py-3 flex md:min-w-[300px] justify-between gap-2 border-b border-b-sleap-gray-400 dark:border-sleap-gray-600">
        <div>
          <span className="font-medium text-base block text-sleap-gray-950 dark:text-white">
            {label}
          </span>
          {!!description && (
            <span className="font-medium text-xs text-sleap-gray-500 block">
              {description}
            </span>
          )}
        </div>
        <div className="flex items-center">
          <button
            disabled={size(value) === min}
            onClick={onDecrement}
            type="button"
            className={`h-10 w-10 flex items-center justify-center bg-sleap-purple-300 shrink-0 p-0 ${size(value) === min && "opacity-30"} text-white  dark:bg-sleap-gray-600`}
          >
            <Minus className="text-white" />
          </button>
          <input type="text" value={String(value.length)} readOnly hidden />
          <span className="block font-bold text-lg w-10 text-center">
            {value.length}
          </span>
          <button
            onClick={onIncrement}
            type="button"
            className="h-10 w-10 flex items-center justify-center bg-sleap-purple-300 shrink-0 p-0 text-white dark:bg-sleap-gray-600"
            disabled={disabledIncrement}
          >
            <Plus className="text-white" />
          </button>
        </div>
      </label>
      {!isEmpty(ageOptions) &&
        value.map((traveller, index) => (
          <CounterAge
            label={label}
            index={index}
            value={traveller.age}
            key={traveller.id}
            ageOptions={ageOptions}
            onAgeChange={(age) => {
              onAgeChange(age, traveller.id);
            }}
          />
        ))}
    </div>
  );
};
